// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"fe8c4904","796":"b5fe17e4"}[chunkId] + ".chunk.js";
};